import { useEffect, useState } from "react";

export interface HeroMediaItem {
  type: "image" | "video";
  src: string;
}

interface HeroBackgroundVideoSliderProps {
  items: HeroMediaItem[];
  interval?: number;
  overlay?: boolean;
  showIndicators?: boolean;
}

export default function HeroBackgroundVideoSlider({
  items,
  interval = 6000,
  overlay = true,
  showIndicators = false,
}: HeroBackgroundVideoSliderProps) {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (items.length <= 1) return;

    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % items.length);
    }, interval);

    return () => clearInterval(timer);
  }, [items.length, interval]);

  return (
    <>
      {items.map((item, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            current === index ? "opacity-100" : "opacity-0"
          }`}
        >
          {item.type === "image" ? (
            <div
              className="w-full h-full bg-cover bg-center"
              style={{
                backgroundImage: `url(${item.src})`,
              }}
            />
          ) : (
            <video
              className="w-full h-full object-cover"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
            >
              <source src={item.src} />
            </video>
          )}
        </div>
      ))}

      {overlay && (
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70" />
      )}

      {showIndicators && items.length > 1 && (
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex gap-2">
          {items.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`w-3 h-3 rounded-full transition-all ${
                current === index
                  ? "bg-white scale-110"
                  : "bg-white/40"
              }`}
            />
          ))}
        </div>
      )}
    </>
  );
}